/**
 * Formatting utilities for admin interface
 */

/**
 * Format currency values
 * @param {number} amount - The amount to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};

/**
 * Calculate time elapsed since timestamp
 * @param {string|number} timestamp - The timestamp to calculate from
 * @param {number} currentTime - Current time in milliseconds (optional)
 * @returns {string} Human-readable time elapsed
 */
export const getMinutesAgo = (timestamp, currentTime = Date.now()) => {
  const diffMs = currentTime - new Date(timestamp).getTime();
  const diffMinutes = Math.floor(diffMs / 60000);
  
  if (diffMinutes < 1) return "Just now";
  if (diffMinutes === 1) return "1 minute ago";
  if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
  if (diffMinutes < 1440) {
    const hrs = Math.floor(diffMinutes / 60);
    return hrs === 1 ? "1 hour ago" : `${hrs} hours ago`;
  }
  const days = Math.floor(diffMinutes / 1440);
  return days === 1 ? "1 day ago" : `${days} days ago`;
};

/**
 * Format date for display
 * @param {string|number} timestamp - The timestamp to format
 * @returns {string} Formatted date string
 */
export const formatDate = (timestamp) => {
  return new Date(timestamp).toLocaleString();
};

/**
 * Get order status based on type and processing state
 * @param {string} key - Order key
 * @param {object} order - Order object
 * @param {Set} emailedKeys - Set of emailed order keys
 * @param {Set} printedKeys - Set of printed order keys
 * @returns {string} Order status
 */
export const getOrderStatus = (key, order, emailedKeys, printedKeys) => {
  if (order.type === 'photo' && emailedKeys.has(key)) {
    return 'Emailed ***Be sure to check their spam folder!***';
  }
  if (order.type === 'gun' && printedKeys.has(key)) {
    return 'Printed';
  }
  return 'New';
};

/**
 * Format order items for display
 * @param {array} items - Array of order items
 * @param {object} gunPackages - Gun package definitions
 * @returns {array} Formatted items array
 */
export const formatOrderItems = (items, gunPackages = {}) => {
  if (!items || !Array.isArray(items)) return [];
  
  return items.map(item => {
    if (gunPackages[item]) {
      return {
        type: 'package',
        name: item,
        items: gunPackages[item]
      };
    }
    return {
      type: 'item',
      name: item
    };
  });
};